/**
 * Container component for consistent page layout
 */
import React from 'react';

type ContainerProps = Readonly<{
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}>;

/**
 * Container component
 */
export const Container: React.FC<ContainerProps> = ({
  children,
  className = '',
  size = 'xl',
}) => {
  const sizeClasses: Record<typeof size, string> = {
    sm: 'max-w-3xl',
    md: 'max-w-5xl',
    lg: 'max-w-7xl',
    xl: 'max-w-screen-2xl',
    full: 'max-w-full',
  };
  
  return (
    <div className={`mx-auto px-4 sm:px-6 lg:px-8 ${sizeClasses[size]} ${className}`}>
      {children}
    </div>
  );
};
